<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.turnover.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table03">
        <p class="l-formGroup__label u-mb10">労働者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="turnover.regularMaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="turnover.nonRegularMaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleEmployee" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="turnover.regularFemaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="turnover.nonRegularFemaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleEmployee" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfRegularEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNonRegularEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAllEmployee" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table03-->

      <div class="human-capitalt-data-wrap__space-mini"></div>

      <div class="human-capitalt-data-wrap__table03">
        <p class="l-formGroup__label u-mb10">離職者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="turnover.regularMaleTurnover" :unit="this.unit"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="turnover.nonRegularMaleTurnover" :unit="this.unit"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleTurnover" :unit="this.unit"/></span></td>
            </tr>
            <tr>
              <th>女性</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="turnover.regularFemaleTurnover" :unit="this.unit"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="turnover.nonRegularFemaleTurnover" :unit="this.unit"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleTurnover" :unit="this.unit"/></span></td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfRegularTurnover" :unit="this.unit"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNonRegularTurnover" :unit="this.unit"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAllTurnover" :unit="this.unit"/></span></td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table03-->

      <div class="human-capitalt-data-wrap__arrow"></div>
    
      <div class="human-capitalt-data-wrap__table03">
        <p class="l-formGroup__label u-mb10">離職率</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfRegularMale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfNonRegularMale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><strong><Currency :value="this.percentageOfAchievementMaleTurnover" :unit="this.unit2"/></strong></span></td>
            </tr>
            <tr>
              <th>女性</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfRegularFemale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfNonRegularFemale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><strong><Currency :value="this.percentageOfAchievementFemaleTurnover" :unit="this.unit2"/></strong></span></td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfRegular" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfNonRegular" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfCorpTurnover" :unit="this.unit2"/></span></td>
            </tr>
          </tbody>
        </table>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(turnover.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(turnover.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の離職率データ
    turnover: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'％',
    }
  },
  computed: {
    // 労働者数（男性）
    sumOfMaleEmployee() {
      if ( !(this.turnover.regularMaleEmployee!=null && this.turnover.nonRegularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleEmployee).length * String(this.turnover.nonRegularMaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleEmployee) || isNaN(this.turnover.nonRegularMaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleEmployee) + Number(this.turnover.nonRegularMaleEmployee);
      }
    },
    // 労働者数（正社員・女性）
    sumOfFemaleEmployee() {
      if ( !(this.turnover.regularFemaleEmployee!=null && this.turnover.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularFemaleEmployee).length * String(this.turnover.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularFemaleEmployee) || isNaN(this.turnover.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.regularFemaleEmployee) + Number(this.turnover.nonRegularFemaleEmployee);
      }
    },
    // 労働者数（正社員）
    sumOfRegularEmployee() {
      if ( !(this.turnover.regularMaleEmployee!=null && this.turnover.regularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleEmployee).length * String(this.turnover.regularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleEmployee) || isNaN(this.turnover.regularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleEmployee) + Number(this.turnover.regularFemaleEmployee);
      }
    },
    // 労働者数（非正規）
    sumOfNonRegularEmployee() {
      if ( !(this.turnover.nonRegularMaleEmployee!=null && this.turnover.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularMaleEmployee).length * String(this.turnover.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularMaleEmployee) || isNaN(this.turnover.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.nonRegularMaleEmployee) + Number(this.turnover.nonRegularFemaleEmployee);
      }
    },
    // 労働者数
    sumOfAllEmployee() {
      if ( !(this.sumOfRegularEmployee!=null && this.sumOfNonRegularEmployee!=null) ) {
        return null;
      }else {
        return Number(this.sumOfRegularEmployee) + Number(this.sumOfNonRegularEmployee);
      }
    },
    // 離職者数（男性）
    sumOfMaleTurnover() {
      if ( !(this.turnover.regularMaleTurnover!=null && this.turnover.nonRegularMaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleTurnover).length * String(this.turnover.nonRegularMaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleTurnover) || isNaN(this.turnover.nonRegularMaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleTurnover) + Number(this.turnover.nonRegularMaleTurnover);
      }
    },
    // 離職者数（女性）
    sumOfFemaleTurnover() {
      if ( !(this.turnover.regularFemaleTurnover!=null && this.turnover.nonRegularFemaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.regularFemaleTurnover).length * String(this.turnover.nonRegularFemaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularFemaleTurnover) || isNaN(this.turnover.nonRegularFemaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.regularFemaleTurnover) + Number(this.turnover.nonRegularFemaleTurnover);
      }
    },
    // 離職者数（正社員）
    sumOfRegularTurnover() {
      if ( !(this.turnover.regularMaleTurnover!=null && this.turnover.regularFemaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleTurnover).length * String(this.turnover.regularFemaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleTurnover) || isNaN(this.turnover.regularFemaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleTurnover) + Number(this.turnover.regularFemaleTurnover);
      }
    },
    // 離職者数（非正規）
    sumOfNonRegularTurnover() {
      if ( !(this.turnover.nonRegularMaleTurnover!=null && this.turnover.nonRegularFemaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularMaleTurnover).length * String(this.turnover.nonRegularFemaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularMaleTurnover) || isNaN(this.turnover.nonRegularFemaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.nonRegularMaleTurnover) + Number(this.turnover.nonRegularFemaleTurnover);
      }
    },
    // 離職者数（全社）
    sumOfAllTurnover() {
      if ( !(this.sumOfRegularTurnover!=null && this.sumOfNonRegularTurnover!=null) ) {
        return null;
      }else {
        return Number(this.sumOfRegularTurnover) + Number(this.sumOfNonRegularTurnover);
      }
    },
    // 離職率（正社員・男性）
      percentageOfRegularMale() {
      if ( !(this.turnover.regularMaleTurnover!=null && this.turnover.regularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleTurnover).length * String(this.turnover.regularMaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleTurnover) || isNaN(this.turnover.regularMaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.regularMaleTurnover == 0 ) return 0;
        if ( this.turnover.regularMaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.regularMaleTurnover) / Number(this.turnover.regularMaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（非正規・男性）
      percentageOfNonRegularMale() {
      if ( !(this.turnover.nonRegularMaleTurnover!=null && this.turnover.nonRegularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularMaleTurnover).length * String(this.turnover.nonRegularMaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularMaleTurnover) || isNaN(this.turnover.nonRegularMaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.nonRegularMaleTurnover == 0 ) return 0;
        if ( this.turnover.nonRegularMaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.nonRegularMaleTurnover) / Number(this.turnover.nonRegularMaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（正社員・女性）
      percentageOfRegularFemale() {
      if ( !(this.turnover.regularFemaleTurnover!=null && this.turnover.regularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularFemaleTurnover).length * String(this.turnover.regularFemaleEmployee).length == 0) {
        return null;
      }else if ( isNaN(this.turnover.regularFemaleTurnover) || isNaN(this.turnover.regularFemaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.regularFemaleTurnover == 0 ) return 0;
        if ( this.turnover.regularFemaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.regularFemaleTurnover) / Number(this.turnover.regularFemaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（非正規・女性）
      percentageOfNonRegularFemale() {
      if ( !(this.turnover.nonRegularFemaleTurnover!=null && this.turnover.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularFemaleTurnover).length *  String(this.turnover.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularFemaleTurnover) || isNaN(this.turnover.nonRegularFemaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.nonRegularFemaleTurnover == 0 ) return 0;
        if ( this.turnover.nonRegularFemaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.nonRegularFemaleTurnover) / Number(this.turnover.nonRegularFemaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
      // 離職率（正社員）
    percentageOfRegular() {
      if ( !(this.sumOfRegularTurnover!=null && this.sumOfRegularEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfRegularTurnover == 0 ) return 0;
        if ( this.sumOfRegularEmployee == 0 ) return null;
        let val = (Number(this.sumOfRegularTurnover) / Number(this.sumOfRegularEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（非正規）
    percentageOfNonRegular() {
      if ( !(this.sumOfNonRegularTurnover!=null && this.sumOfNonRegularEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfNonRegularTurnover == 0 ) return 0;
        if ( this.sumOfNonRegularEmployee == 0 ) return null;
        let val = (Number(this.sumOfNonRegularTurnover) / Number(this.sumOfNonRegularEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（男性）
    percentageOfAchievementMaleTurnover() {
      if ( !(this.sumOfMaleTurnover!=null && this.sumOfMaleEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfMaleTurnover == 0 ) return 0;
        if ( this.sumOfMaleEmployee == 0 ) return null;
        let val = (Number(this.sumOfMaleTurnover) / Number(this.sumOfMaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（女性）
    percentageOfAchievementFemaleTurnover() {
      if ( !(this.sumOfFemaleTurnover!=null && this.sumOfFemaleEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfFemaleTurnover == 0 ) return 0;
        if ( this.sumOfFemaleEmployee == 0 ) return null;
        let val = (Number(this.sumOfFemaleTurnover) / Number(this.sumOfFemaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（全社）
    percentageOfCorpTurnover() {
      if ( !(this.sumOfAllTurnover!=null && this.sumOfAllEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfAllTurnover == 0 ) return 0;
        if ( this.sumOfAllEmployee == 0 ) return null;
        let val = (Number(this.sumOfAllTurnover) / Number(this.sumOfAllEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
  },
  watch: {
    femalePercentage() {
      this.inputFemalePercentage();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputFemalePercentage() {
      this.$emit("change-female-percentage-detail", {
        femalePercentage: this.femalePercentage,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
